import React from "react";
import styles from "./recordings.page.module.scss";

const statCards = [
  { label: "Total Recordings", value: "8", tone: "default" },
  { label: "Positive", value: "3", tone: "positive" },
  { label: "Negative", value: "3", tone: "negative" },
  { label: "Mixed/Neutral", value: "2", tone: "neutral" },
];

const recordings = [
  {
    id: "LAG001",
    location: "Calamba, Laguna",
    coordinates: "14.2167, 121.1653",
    date: "3/21/2026",
    time: "2:30 PM",
    demographics: "35-44 - Female - Retail/Trade",
    residing: "Born Here",
    summary:
      "Respondent expressed frustration about poor road conditions, flooding, and lack of street lighting.",
    sentiment: "negative",
    tone: "frustrated",
    concerns: ["Poor road conditions", "Flooding", "Lack of street lighting"],
  },
  {
    id: "LAG002",
    location: "Santa Rosa, Laguna",
    coordinates: "14.3122, 121.1114",
    date: "3/25/2026",
    time: "3:45 PM",
    demographics: "65+ - Male - Retired",
    residing: "Born Here",
    summary:
      "Positive feedback about the new health center and medicine availability for senior citizens.",
    sentiment: "positive",
    tone: "hopeful",
    concerns: ["Healthcare accessibility"],
  },
  {
    id: "LAG003",
    location: "Binan, Laguna",
    coordinates: "14.3386, 121.0867",
    date: "4/2/2026",
    time: "4:20 PM",
    demographics: "35-44 - Female - Domestic",
    residing: "10+ years",
    summary:
      "Mother worried about overcrowded public schools, classroom shortages, and teacher gaps.",
    sentiment: "negative",
    tone: "concerned",
    concerns: ["Overcrowded schools", "Lack of classrooms", "Teacher shortage"],
  },
];

const RecordingsPage = () => {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1>Survey Recordings</h1>
        <p>Browse and analyze all submitted survey recordings</p>
      </div>

      <section className={styles.statsGrid}>
        {statCards.map((card) => (
          <article key={card.label} className={styles.statCard}>
            <p>{card.label}</p>
            <strong className={styles[card.tone]}>{card.value}</strong>
          </article>
        ))}
      </section>

      <section className={styles.recordingsList}>
        {recordings.map((item) => (
          <article key={item.id} className={styles.recordingCard}>
            <div className={styles.recordingTop}>
              <div>
                <p className={styles.metaLabel}>Location</p>
                <h3>{item.location}</h3>
                <small>{item.coordinates}</small>
              </div>

              <div>
                <p className={styles.metaLabel}>Date & Campaign</p>
                <p className={styles.inlineMeta}>{item.date}</p>
                <small>{item.time}</small>
                <div className={styles.campaignCode}>{item.id}</div>
              </div>

              <div>
                <p className={styles.metaLabel}>Demographics</p>
                <p className={styles.inlineMeta}>{item.demographics}</p>
                <small>
                  <span>Residing:</span> {item.residing}
                </small>
              </div>

              <div>
                <p className={styles.metaLabel}>Executive Summary</p>
                <p className={styles.summary}>{item.summary}</p>
              </div>

              <div className={styles.sideMeta}>
                <p className={styles.metaLabel}>Sentiment</p>
                <span className={styles[item.sentiment]}>{item.sentiment}</span>
                <small>
                  <span>Tone:</span> {item.tone}
                </small>
              </div>
            </div>

            <div className={styles.concernsRow}>
              <p className={styles.metaLabel}>Key Concerns</p>
              <div>
                {item.concerns.map((concern) => (
                  <span key={concern}>{concern}</span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default RecordingsPage;
